<template>
    <div class="col-md-12 m-t-20">
        <div class="card">
            <div class="card-header m-t-10">
                <div class="row">
                    <div class="d-md-flex align-items-center col-md-6">
                        <div>
                            <h4 class="m-b-0 card-title">Sale Order Summary</h4>
                            <h5 class="card-subtitle">Comprehensive summary details of sale</h5>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row">
                            <div class="col-md-6">
                                <v-md-date-range-picker
                                        :auto-apply="false"
                                        :opens="opens"
                                        :show-activator-bar="false"
                                        :show-activator-label="false"
                                        :show-custom-range-label="value"
                                        @change="change"
                                        show-year-select>
                                </v-md-date-range-picker>
                            </div>
                            <div class="col-md-2">
                                <button @click="getSoSummaryInRange(1)" class="btn btn-light btn-outline-success" style="height: 42px;" type="button">Go!</button>
                            </div>
                            <div class="col-md-2 btn-arrange">
                                <button @click="reset()" class="btn btn-light btn-outline-secondary" style="height: 42px;" type="button">Reset!</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row m-t-30">
                    <div class="col-lg-4 col-md-12 col-sm-12 m-b-30">
                        <div class="row">
                            <div class="col-4 border-right">
                                <i class="fa fa-circle text-cyan"></i>
                                <h3 class="m-b-0 font-medium">{{draftCount}}</h3>
                                <span>Draft</span>
                            </div>
                            <div class="col-4 border-right">
                                <i class="fa fa-circle text-primary"></i>
                                <h3 class="m-b-0 font-medium">{{confirmedCount}}</h3>
                                <span>Confirmed</span>
                            </div>
                            <div class="col-4 border-right">
                                <i class="fa fa-circle text-brown"></i>
                                <h3 class="m-b-0 font-medium">{{dropShipCount}}</h3>
                                <span>Drop Shipment</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-12 col-sm-12  m-b-30">
                        <div class="row">
                            <div class="col-4 border-right">
                                <i class="fa fa-circle text-orange"></i>
                                <h3 class="m-b-0 font-medium">{{backOrderCount}}</h3>
                                <span>Back Order</span>
                            </div>
                            <div class="col-4 border-right">
                                <i class="fa fa-circle text-success"></i>
                                <h3 class="m-b-0 font-medium">{{packedCount}}</h3>
                                <span>Packed</span></div>
                            <div class="col-4 border-right">
                                <i class="fa fa-circle text-indigo"></i>
                                <h3 class="m-b-0 font-medium">{{invoiceCount}}</h3>
                                <span>Invoiced</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-12 col-sm-12  m-b-30">
                        <div class="row">
                            <div class="col-4 border-right">
                                <i class="fa fa-circle text-light-green"></i>
                                <h3 class="m-b-0 font-medium">{{shipCount}}</h3>
                                <span>Shipped</span>
                            </div>
                            <div class="col-4 border-right">
                                <i class="fa fa-circle text-dark-green"></i>
                                <h3 class="m-b-0 font-medium">{{fulfilledCount}}</h3>
                                <span>Fulfilled</span></div>
                            <div class="col-4 border-right">
                                <i class="fa fa-circle text-inverse"></i>
                                <h3 class="m-b-0 font-medium">{{closedCount}}</h3>
                                <span>Closed</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card card-body printableArea m-t-10">
                <div class="row">
                    <div class="col-md-12">
                        <div class="table-responsive " style="clear: both;">
                            <table class="table table-hover">
                                <thead>
                                <tr>
                                    <th class="text-left">Status</th>
                                    <th class="text-left">Number</th>
                                    <th class="text-left">Created On</th>
                                    <th class="text-left">Amount</th>
                                    <th class="text-left">Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(s, index) in so">
                                    <td class="text-left">
                                        <span class="label label-cyan" v-if="s.status === 'DRAFT'">Draft</span>
                                        <span class="label label-primary" v-if="s.status === 'CONFIRMED'">Confirmed</span>
                                        <span class="label label-inverse" v-if="s.status === 'CLOSED'">Closed</span>
                                        <span class="label label-brown" v-if="s.status === 'DROP_SHIPMENT'">Drop Shipment</span>
                                        <span class="label label-orange" v-if="s.status === 'BACK_ORDER'">Back Order</span>
                                        <span class="label label-success" v-if="s.status === 'PACKED'">Packed</span>
                                        <span class="label label-indigo" v-if="s.status === 'INVOICED'">Invoiced</span>
                                        <span class="label label-light-green" v-if="s.status === 'SHIPPED'">Shipped</span>
                                        <span class="label label-dark-green" v-if="s.status === 'FULFILLED'">Fulfilled</span>
                                    </td>
                                    <td class="text-left">{{s.id}}</td>
                                    <td class="text-left">{{s.created_at | date}}</td>
                                    <td class="text-left">{{s.total | money}}</td>
                                    <td class="text-left">
                                        <a @click="viewSo(s.id)" href="javascript:void(0)">
                                            <h6>View Details</h6>
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <span>Showing {{pageNumber}} of {{pageCount}}</span>
                    </div>
                    <div class="col-6">
                        <paginate
                                :click-handler="pageHandler"
                                :container-class="'pagination float-right'"
                                :margin-pages="2"
                                :next-class="'page-link'"
                                :next-text="'Next'"
                                :page-class="'page-link'"
                                :page-count=pageCount
                                :page-range="3"
                                :prev-class="'page-link'"
                                :prev-text="'Prev'"
                                v-model="pageNumber">
                        </paginate>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import Paginate from 'vuejs-paginate';

    export default {
        name: "Sales",
        props: ["memberid", "events"],
        computed: {
            ...mapGetters(["currentOrg"])
        },
        components: {Paginate},
        data() {
            return {
                so: [],
                draftCount: 0,
                confirmedCount: 0,
                dropShipCount: 0,
                backOrderCount: 0,
                packedCount: 0,
                invoiceCount: 0,
                shipCount: 0,
                fulfilledCount: 0,
                closedCount: 0,
                pageCount: 1,
                pageNumber: 1,
                total: 0,
                so_from_date: null,
                so_to_date: null,
                opens: 'left',
                value: true
            }
        },
        mounted() {
            this.getSoSummary(1);
        },
        methods: {
            change(e) {
                this.so_from_date = e[0].toDate();
                this.so_to_date   = e[1].toDate();
            },
            async getSoSummary(page) {
                $(".preloader").fadeIn();
                let result = await this.$http
                .get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/" + this.memberid + "/saleSummary", {
                    params: {
                        page: page,
                        perPage: 3
                    }
                });

                $(".preloader").fadeOut();
                this.total = result.data.total;
                this.so    = result.data.so;
                let allSo  = result.data.allSo;

                let draftSo         = await _.filter(allSo, {"status": "DRAFT"});
                let confirmedSo     = await _.filter(allSo, {"status": "CONFIRMED"});
                let dropShipSo      = await _.filter(allSo, {"status": "DROP_SHIPMENT"});
                let backOrderSo     = await _.filter(allSo, {"status": "BACK_ORDER"});
                let packedSo        = await _.filter(allSo, {"status": "PACKED"});
                let invoicedSo      = await _.filter(allSo, {"status": "INVOICED"});
                let shippedSo       = await _.filter(allSo, {"status": "SHIPPED"});
                let fulfilledSo     = await _.filter(allSo, {"status": "FULFILLED"});
                let closedSo        = await _.filter(allSo, {"status": "CLOSED"});
                this.draftCount     = draftSo.length;
                this.confirmedCount = confirmedSo.length;
                this.dropShipCount  = dropShipSo.length;
                this.backOrderCount = backOrderSo.length;
                this.packedCount    = packedSo.length;
                this.invoiceCount   = invoicedSo.length;
                this.shipCount      = shippedSo.length;
                this.fulfilledCount = fulfilledSo.length;
                this.closedCount    = closedSo.length;
                this.setPageCount();
            },
            async getSoSummaryInRange(page) {
                $(".preloader").fadeIn();
                let result = await this.$http
                .get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/" + this.memberid + "/saleSummary", {
                    params: {
                        page: page,
                        perPage: 3,
                        fromDate: this.so_from_date,
                        toDate: this.so_to_date
                    }
                });

                $(".preloader").fadeOut();
                this.total = result.data.total;
                this.so    = result.data.so;
                let allSo  = result.data.allSo;

                let draftSo         = await _.filter(allSo, {"status": "DRAFT"});
                let confirmedSo     = await _.filter(allSo, {"status": "CONFIRMED"});
                let dropShipSo      = await _.filter(allSo, {"status": "DROP_SHIPMENT"});
                let backOrderSo     = await _.filter(allSo, {"status": "BACK_ORDER"});
                let packedSo        = await _.filter(allSo, {"status": "PACKED"});
                let invoicedSo      = await _.filter(allSo, {"status": "INVOICED"});
                let shippedSo       = await _.filter(allSo, {"status": "SHIPPED"});
                let fulfilledSo     = await _.filter(allSo, {"status": "FULFILLED"});
                let closedSo        = await _.filter(allSo, {"status": "CLOSED"});
                this.draftCount     = draftSo.length;
                this.confirmedCount = confirmedSo.length;
                this.dropShipCount  = dropShipSo.length;
                this.backOrderCount = backOrderSo.length;
                this.packedCount    = packedSo.length;
                this.invoiceCount   = invoicedSo.length;
                this.shipCount      = shippedSo.length;
                this.fulfilledCount = fulfilledSo.length;
                this.closedCount    = closedSo.length;
                this.setPageCount();
            },
            pageHandler(pageNum) {
                this.pageNumber = pageNum;
                if(this.so_from_date === null || this.so_to_date === null) {
                    this.getSoSummary(pageNum);
                } else {
                    this.getSoSummaryInRange(pageNum)
                }
            },
            setPageCount() {
                this.pageCount = this.total <= 3 ? 1 : Math.ceil(this.total / 3);
            },
            viewSo(soid) {
                this.$router.push({name: "viewsale", params: {saleid: soid}});
            }
        }
    }
</script>

<style scoped>
    .btn-arrange {
        margin-left: -38px;
    }
</style>
